'use client';

import { create } from 'zustand';

/**
 * Global open/close state for the shared "create building" dialog.
 *
 * The dialog used to live only on the (now removed) Dashboard page. With the
 * project page as the app home, project creation is triggered from several
 * places — the project header ⋮ menu, the project switcher list, and the
 * no-projects empty state. A single store lets every trigger open one dialog
 * instance mounted once in the authenticated layout (DRY).
 */
interface NewProjectState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useNewProjectStore = create<NewProjectState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
